import React, { useState, useEffect } from "react";
import "../../../assets/scss/components/externalTotp.scss";
import EdButton from "../../../components/generic/edButton";
import LoginPopup from "../../../components/login/generic/loginPopup";
import OtpForm from "../../../components/login/forms/otpForm";
import DeviceContext from "../../../services/indentifyDevice";
import InputField from "../../../components/generic/inputField";
import EtotpIcon from "../../../assets/images/TotpIcon.png"
import NuvamaLogo from "../../../assets/new_images/nuvama-logo.svg";
import ConfirmPopup from "../../../components/generic/confirmPopup";
import GreenTick from "../../../assets/images/greenTick.png"
import { getTolocalStorage } from "../../Constants/commenFeatures";
import loginService from "../../../services/login/loginService";
import { accRedircet } from "../../../services/genralServise";
import { config } from "../../../config/domain";
import { disableEtotp, etotpSendOtp, validatePassword } from "../../../services/ExternalTOTP/etotpApiService";
import LoginService from "../../../services/login/loginService";
import LoginErrMsg from "../../../components/login/generic/loginErrMsg";
import { Link } from "react-router-dom";

const DisableFlow = () => {
    const [otpScreen, setOtpScreen] = useState(false);
    const [userId, setUserId] = useState("");
    const [apiError, setApiError] = useState("");
    const [accTyp, setAccTyp] = useState("");
    const [otp, setOtp] = useState("");
    // const [email, setEmail] = useState("");
    const [oldPwd, setOldPwd] = useState("");
    const [confirmationPopup, setConfirmationPopup] = useState(false);
    const [finalPopup, setFinalPopup] = useState(false);
    const [showPassword, setShowPassword] = React.useState(false);
    const [disableTotp, setDisableTotp] = useState(false);
    
    useEffect(() => {
        let userId = LoginService.getAccData("userID");
        let acntTyp = LoginService.getAccData("accTyp");
        if(acntTyp === "COMEQ")
            acntTyp = localStorage.getItem("accntTyp");
        setUserId(userId);
        setAccTyp(acntTyp);
        // let emaild = LoginService.getAccData("accs").eml;
        // let emailName = emaild.replace(/(?<=.{2}).(?=[^@]*?@)/g, "*");  
        // setEmail(emailName);   
    },[]);

    function validatePwd (){
        validatePassword(validatePwdRes, userId, oldPwd)
    }
    const validatePwdRes = (res: any) =>{
        if (res.data && res?.data) {
            generateOtp();     
        } else if (res.error) {
            setApiError(res.error.errMsg);        
                setTimeout(() => {
                    setApiError("");
                }, 10000);
        }
    }
    function generateOtp (){
        setApiError("");
        etotpSendOtp(generateOtpRes, userId, accTyp);  
    }
    const generateOtpRes = (res: any) => {
        if (res.data && res?.data) {
            setOtpScreen(true);     
        } else if (res.error) {
            setApiError(res.error.errMsg);
            setTimeout(() => {
                setApiError("");
            }, 5000);
        }
    };
    // function validateOtp(){
    //     let payload = {
    //         userId: userId,
    //         acTyp: accTyp,
    //         otp: otp,
    //     };
    //     ValidateEtotpOtp(validateOtpRes, payload)
    // }
    // const validateOtpRes = (res: any) => {
    //     if (res?.data && res.data ) {
    //         setConfirmationPopup(true);
    //     } else if (res.error) {
    //         setApiError(res.error.errMsg);
    //         setOtp("");
    //         setTimeout(() => {
    //             setApiError("");
    //         }, 5000);
    //     }
    // };
    function disableEtotpFlow(){
        let payload = {
            userId: userId,
            acTyp: accTyp,
            otp: otp
        };
        disableEtotp(disableEtotpFlowRes, payload);    
    }
    const disableEtotpFlowRes = (res: any) => {
        if (res.data && res?.data) {
            setFinalPopup(true);
        } else if (res.error) {
            setApiError(res.error.errMsg);
            setOtp("");
            setConfirmationPopup(false);
            setTimeout(() => {
                setApiError("");
            }, 5000);
        }
    };
    function removeError(){
        setOtp("");
        setApiError("");
    }
    function dontProceed(){
        setDisableTotp(false);
        setOtpScreen(false);
        setConfirmationPopup(false);
        setFinalPopup(false);
    }
    const logout = () => {
        let loginAs = getTolocalStorage("loginAs");
        if (loginAs === "vendor") {
          loginService.vendorLogout();
        } else {
          loginService.logout();
        }
        accRedircet(config.root);
    };
    const unblockLogout = () => {
        let loginAs = getTolocalStorage("loginAs");
        if (loginAs === "vendor") {
          loginService.vendorLogout();
        } else {
          loginService.logout();
        }
        accRedircet(config.root);
    };
    return (
        <>
        <div className="totp-container">
            { !otpScreen && <div className="totp-content-container">
            <h5 className="heading pd-b43">External 2FA TOTP</h5>
                <div>
                    <div className="row">
                        <div className="column-left">
                            <img src={EtotpIcon} alt="External TOTP icon"></img>
                        </div>
                        <div className="column-right">
                            <h5 className="sub-heading">External TOTP is enabled on your account</h5>
                            <p className="totp-info pd-b30">Every  time you login, you will be prompted to enter a 6 digit TOTP that your external mobile authenticator app generates.</p> 
                            <p className="totp-info pd-b30">Even if external TOTP is disabled, you can login to your account using OTP.</p>
                            <div className="display-center2">
                                <EdButton
                                    value="Disable external TOTP"
                                    btnTyp="secondary"
                                    disabled={disableTotp}
                                    className="submit_btn btn-w240 mg-b40"
                                    onClick= {() => setDisableTotp(true)}
                                />
                            </div>
                            {disableTotp && (
                                <>
                                <br/>
                                <label className="totp-info mg-b5 ib">Enter your Password to confirm</label>
                                <InputField
                                defaultValue={oldPwd ? oldPwd : ""}
                                id="oldPwd"
                                type={showPassword ? "text" : "password"}
                                onChange={setOldPwd}
                                onBlur={() => {}}
                                className="login_inp mg-b15 etotp-btn-w400 btn-wXS"
                                placeholder="Enter password"
                                autoFocus={false}
                                suffix={
                                    <i
                                    className={`edel-icon-eye${showPassword ? "-cross" : ""} icon`}
                                    onClick={() => setShowPassword(!showPassword)}
                                    />
                                }
                                />
                                <p className="etotp-btn-w400 greyText font-12 mg-b40">Important: Once external TOTP is setup. you have to use the same mobile authenticator app to generate a new 6-digit TOTP every time you login.</p>
                                <div className="display-center">
                                    <EdButton
                                        value="Cancel"
                                        btnTyp="secondary"
                                        className="submit_btn btn-w195 etotp-btn"
                                        onClick= {dontProceed}
                                    />
                                    <EdButton
                                        value="Disable"
                                        btnTyp="primary"
                                        className="submit_btn btn-w195 etotp-btn"
                                        onClick= {validatePwd}
                                    />
                                </div>
                                </>                              
                            )}
                            {apiError && (
                                <LoginErrMsg className="mg-t30 btn-w380">
                                    {apiError}
                                    <br/>
                                    { apiError == "Error occurred :User Is Blocked" && (
                                        <Link to="/login/unblock-account" className="help_links ib">
                                        <br/>
                                        <span onClick={unblockLogout}>Unblock account</span>
                                        <i className="edel-icon-go" />
                                        </Link>
                                    )}
                                </LoginErrMsg>
                            )}
                        </div>                   
                    </div>       
                </div>   
            </div>}
            {otpScreen && 
                (<LoginPopup
                    leftHeaderContent={
                        !DeviceContext().isDesktop ? (
                        <img className="logo1" src={NuvamaLogo} alt="nuvama-logo" />
                        ) : undefined
                    }
                    centerHeaderContent={
                        DeviceContext().isDesktop ? (
                        <img className="logo1" src={NuvamaLogo} alt="nuvama-logo" />
                        ) : undefined
                    }
                    onClose={() => {
                        setOtpScreen(false);
                        removeError();
                    }}
                    className="login_scrn"
                    overlayClass="overlay_component"
                >
                    <h5 className="text-center sub-heading otp-header">Verify OTP</h5>
                    <OtpForm 
                        disableForm={false}
                        onSubmit={(otp)=>setOtp(otp)}
                        onChangeFunc={(otp)=>setOtp(otp)}
                        onClose={() => setOtpScreen(false)}
                        containerClass= "mg-t10 mg-b0"
                        onRemoveError={removeError}
                        onTimerClose={() => {}}
                        errorMsg={apiError}
                        showResend={true}
                        ResendFunction={generateOtp}
                        otpTitle={"We have sent an OTP to your registered email address and mobile number"}
                    />
                    <EdButton
                    value="Verify"
                    disabled={otp.length!=4}
                    btnTyp="primary"
                    className="wd-400 btn-wXS align-center"
                    onClick={()=>setConfirmationPopup(true)}
                    />
                    { confirmationPopup && (
                        <ConfirmPopup
                        heading=""
                        heading2="Your active sessions on all Nuvama platforms will expire, would you like to proceed."
                        subHeading=""
                        buttonPrimary={true}
                        buttonSecondary={true}
                        buttonPrimaryValue="Yes"
                        buttonSecondaryValue="No"
                        OnclickBtnP={disableEtotpFlow}
                        OnclickBtnS={dontProceed}
                        />
                    )}
                    { finalPopup && (
                        <ConfirmPopup
                        heading="Done"
                        subHeading="External TOTP is disabled now and your active sessions on all Nuvama platforms are expired. Please re-login to continue"
                        buttonPrimary={false}
                        buttonSecondary={true}
                        imageSrc={GreenTick}
                        imgAlt="Enabled Icon"
                        buttonSecondaryValue="Ok Got, it"
                        OnclickBtnS={logout}
                        />
                    )}
                </LoginPopup>
            )}
        </div>
        </>
    )
}
export default DisableFlow;